import { ISelectOption } from './selectOption.interface';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { RuleCategory } from '../api/governance/violationRule.model';

export const ViolationCategorySelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.ViolationCategory.toString()}-${RuleCategory.custom_code}`,
    value: RuleCategory.custom_code,
    displayName: RuleCategory.custom_code,
    categoryName: FilterTypesEnum.ViolationCategory.toString(),
    filterType: FilterTypesEnum.ViolationCategory,
  },
  {
    id: `${FilterTypesEnum.ViolationCategory.toString()}-${RuleCategory.authentication}`,
    value: RuleCategory.authentication,
    displayName: RuleCategory.authentication,
    categoryName: FilterTypesEnum.ViolationCategory.toString(),
    filterType: FilterTypesEnum.ViolationCategory,
  },
  {
    id: `${FilterTypesEnum.ViolationCategory.toString()}-${RuleCategory.data_flow}`,
    value: RuleCategory.data_flow,
    displayName: RuleCategory.data_flow,
    categoryName: FilterTypesEnum.ViolationCategory.toString(),
    filterType: FilterTypesEnum.ViolationCategory,
  },
  {
    id: `${FilterTypesEnum.ViolationCategory.toString()}-${RuleCategory.encryption}`,
    value: RuleCategory.encryption,
    displayName: RuleCategory.encryption,
    categoryName: FilterTypesEnum.ViolationCategory.toString(),
    filterType: FilterTypesEnum.ViolationCategory,
  },
  {
    id: `${FilterTypesEnum.ViolationCategory.toString()}-${RuleCategory.environment_separation}`,
    value: RuleCategory.environment_separation,
    displayName: RuleCategory.environment_separation,
    categoryName: FilterTypesEnum.ViolationCategory.toString(),
    filterType: FilterTypesEnum.ViolationCategory,
  },
  {
    id: `${FilterTypesEnum.ViolationCategory.toString()}-${RuleCategory.identity_management}`,
    value: RuleCategory.identity_management,
    displayName: RuleCategory.identity_management,
    categoryName: FilterTypesEnum.ViolationCategory.toString(),
    filterType: FilterTypesEnum.ViolationCategory,
  },
  {
    id: `${FilterTypesEnum.ViolationCategory.toString()}-${RuleCategory.least_privilege}`,
    value: RuleCategory.least_privilege,
    displayName: RuleCategory.least_privilege,
    categoryName: FilterTypesEnum.ViolationCategory.toString(),
    filterType: FilterTypesEnum.ViolationCategory,
  },
  {
    id: `${FilterTypesEnum.ViolationCategory.toString()}-${RuleCategory.security_monitoring}`,
    value: RuleCategory.security_monitoring,
    displayName: RuleCategory.security_monitoring,
    categoryName: FilterTypesEnum.ViolationCategory.toString(),
    filterType: FilterTypesEnum.ViolationCategory,
  },
  {
    id: `${FilterTypesEnum.ViolationCategory.toString()}-${RuleCategory.third_party_dependency}`,
    value: RuleCategory.third_party_dependency,
    displayName: RuleCategory.third_party_dependency,
    categoryName: FilterTypesEnum.ViolationCategory.toString(),
    filterType: FilterTypesEnum.ViolationCategory,
  },
];
